import mitt from 'mitt'

const eventBus = mitt()

export { eventBus }

export default function (app) {
  app.provide('eventBus', eventBus)
}
